import constants from 'redux/constants';

export const showNotification = notification => ({
  type: constants.ui.SHOW_NOTIFICATION,
  payload: { notification },
});
